<script lang="ts">
	// @ts-nocheck
	import Button from '$lib/components/ui/button/button.svelte';
	import { tourContent } from '$lib/utils/tourContent';
	import * as Accordion from '$lib/components/ui/accordion';
	import { Check } from 'lucide-svelte';
	import { cubicInOut } from 'svelte/easing';
	import { crossfade, fade, fly } from 'svelte/transition';
	import { illustrationImages } from '$lib/utils/images';

	let { tour, rezdyLink } = $props();

	let highlights = tourContent.find((t) => t.productCode === tour.productCode)?.accordionContent;
	let features = tourContent.find((t) => t.productCode === tour.productCode)?.features;
	let current = 0;

	const [send, receive] = crossfade({
		duration: 500,
		easing: cubicInOut
	});
</script>

<!-- FEATURES -->
{#if features}
	<section class="relative overflow-hidden">
		<div class="mx-auto max-w-7xl px-4 py-24">
			<h2
				class=" mt-10 scroll-m-20 pb-2 font-heading text-2xl font-semibold tracking-tight transition-colors first:mt-0 lg:text-3xl"
			>
				What's included?
			</h2>
			<div class="flex w-full flex-col py-12">
				<div class="flex grid-cols-1 flex-col gap-12 lg:flex-row">
					{#each features as feature, index}
						<div class="col-span-1 flex w-full flex-col">
							<enhanced:img
								src={Object.entries(illustrationImages).find(
									([key, value]) => key === feature.image
								)[1].default}
								class="w-36"
								alt={feature.title}
								sizes="144px"
								loading="lazy"
							/>

							<Accordion.Root class="w-full  " value="item-0">
								<Accordion.Item value="item-{index}" class="">
									<Accordion.Trigger class="font-heading text-lg font-semibold"
										>{feature.title}</Accordion.Trigger
									>
									<Accordion.Content class="text-md">
										{@html feature.content}
									</Accordion.Content>
								</Accordion.Item>
							</Accordion.Root>
							<!-- <h3 class="mb-4 font-heading text-lg font-semibold lg:text-xl">{feature.title}</h3>
							{@html feature.content} -->
						</div>
					{/each}
				</div>
			</div>
		</div>
	</section>
{/if}

<!-- HIGHLIGHTS -->
{#if highlights}
	<!-- ACCORDION -->

	<section class="relative overflow-hidden bg-[#194139]">
		<div class="mx-auto max-w-7xl px-4 py-12">
			<h2
				class="mx-auto mt-10 scroll-m-20 pb-2 text-center font-heading text-2xl font-semibold tracking-tight text-background transition-colors first:mt-0 lg:text-3xl"
			>
				Itinerary
			</h2>

			<div class="mx-auto max-w-3xl">
				<Accordion.Root type="single" class="w-full  py-12 text-background" value="item-0">
					{#each highlights as item, index}
						<Accordion.Item value="item-{index}" class="border-background/40">
							<Accordion.Trigger class="text-lg ">{@html item.title}</Accordion.Trigger>
							<Accordion.Content>
								{@html item.content}
							</Accordion.Content>
						</Accordion.Item>
					{/each}
				</Accordion.Root>
			</div>
			<div class="mx-auto w-full text-center">
				<Button
					data-sveltekit-noscroll
					href={rezdyLink}
					class="button-booking rezdy rezdy-modal pointer-events-auto mx-auto mt-8 w-44 rounded-full bg-tt-red px-6 text-lg font-semibold hover:bg-tt-red/90 "
					>Book now</Button
				>
			</div>
		</div>
	</section>
{/if}
